import React from 'react';
import { H2 as Title, H5 as Question } from '@rezdy/components/Heading';
import TextStyle from '@rezdy/components/TextStyle';
import Grid from '@rezdy/components/Grid';
// import Button from '@rezdy/components/Button';

import Answer from './Answer';

export interface IOption {
    value: string;
    label: string;
}

interface IQuestionForm {
    title: string;
    options: IOption[];
    selected?: string;
    onSelect: (option: IOption) => void;
}

export class QuestionForm extends React.PureComponent<IQuestionForm> {
    render() {
        const { title, options } = this.props;

        return (
            <div style={{ padding: 20 }}>
                {/* <TextStyle align="left" weight="bold"> */}
                {/* <Title>Welcome John</Title> */}
                {/* </TextStyle> */}
                {/* <TextStyle align="left" as="p" weight="light">
                    Almost there! Just 3 more questions about your business to help us put you on the right path.
                </TextStyle> */}
                {/* <TextStyle align="left" weight="bold"> */}
                <Question>{title}</Question>
                {/* </TextStyle> */}
                <div style={{ paddingTop: 20, paddingBottom: 20 }}>
                    <Grid.Container cols={2} colGap rowGap>
                        {options.map((option: IOption) => (
                            <Grid.Cell key={option.value}>
                                <Answer
                                    onClick={() => {
                                        this.props.onSelect(option);
                                    }}
                                    isSelected={option.value === this.props.selected}
                                >
                                    {option.label}
                                </Answer>
                            </Grid.Cell>
                        ))}
                    </Grid.Container>
                </div>
            </div>
        );
    }
}

export default QuestionForm;
